import { render, staticRenderFns } from "./TagAddingModal.vue?vue&type=template&id=04c9ee7c&scoped=true"
import script from "./TagAddingModal.vue?vue&type=script&lang=js"
export * from "./TagAddingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c9ee7c",
  null
  
)

export default component.exports